export default 'tago';